var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: {
      title: "图文列表-2",
      component_name: "3-2-graphic-list-2",
      initConfigNum: 3,
      styleConfig: _vm.styleConfig,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }